module.exports = __webpack_public_path__ + "img/e-1.1ccf47fb.jpg";